import { Component, Inject, Provide, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import Home from './components/home/Home';
import Events from './components/events/Events';
import EventDetail from './components/events/eventDetail/EventDetail';
import PageBuilder from './components/pageBuilder/PageBuilder';
import Account from './components/account/Account';
import $ from 'jquery';
import Main from './main.js';

Vue.filter('trans', function (key, vars, domain) {
  vars = vars || {};
  domain = domain || 'S5AppEventBundle';

  return Translator.trans(key, vars, domain);
});

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value;
  }
  var formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

@Component({
  components: {
    Home,
    Events,
    EventDetail,
    PageBuilder,
    Account
  }
})
export default class App extends Vue {
  @Provide('eventsData')
  eventsData = {
    isLoading: true,
    events: null
  }

  @Provide('pageBuilderData')
  pageBuilderData = {
    pageBuilders: {},
    allFormsValid: true
  }

  @Provide('storageData')
  storageData = {
    cart: {},
    forms: {
      stepOne: {},
      stepTwo: {},
      stepThree: {},
      stepFour: {}
    }
  }

  @Provide('categoryData')
  categoryData = {
    isLoading: true,
    categories: null
  }

  @Provide('organiserData')
  organiserData = {
    isLoading: true,
    organisers: null
  }

  @Provide('user')
  user = {
    token: null,
    userData: null
  }

  userIsLoading = true;

  dataStorageId = null;

  errorMessage = null;

  parentUrl = 'https://www.mercedes-benz.com/de/mercedes-benz/event/circle-of-excellence/circle-of-excellence-booking/';

  @Provide('promises')
  promises = {
    events: {
      promise: null,
      resolve: null
    }
  }

  fetchAllEvents () {
    let urls = $('#api-links').data('api-links');
    let proxy = this;
    return axios.get(urls.apiEventsAll, { responseType: 'json' }).then(function (response) {
      proxy.promises.events.resolve();
      proxy.eventsData.events = response.data;
      proxy.eventsData.isLoading = false;
    });
  }

  fetchAllCategories () {
    let urls = $('#api-links').data('api-links');
    let proxy = this;
    return axios.get(urls.apiCategoriesAll, { responseType: 'json' }).then(function (response) {
      proxy.categoryData.categories = response.data;
      proxy.categoryData.isLoading = false;
    });
  }

  fetchAllOrganisers () {
    let urls = $('#api-links').data('api-links');
    let proxy = this;
    return axios.get(urls.apiOrganisersAll, { responseType: 'json' }).then(function (response) {
      proxy.organiserData.organisers = response.data;
      proxy.organiserData.isLoading = false;
    });
  }

  @Provide('currentLocale')
  currentLocale () {
    return Translator.locale;
  }

  checkLogin () {
    let proxy = this;

    // check if access token is already set
    if (!this.user.token) {
      // try if user is already logged in:
      let checkUrl = 'https://www.mercedes-benz.com/profile/mobile-token';
      return axios.get(checkUrl,
        {
          responseType: 'json',
          withCredentials: true,
          crossDomain: true
        })
        .then(function (response) {
          if (response.status === 200) {
            Vue.set(proxy.user, 'token', response.data.accessToken);
            return proxy.fetchUserData();
          } else if (response.status === 403) {
          // redirect to login
            proxy.loginUser();
          } else {
            proxy.errorMessage = 'api_error_main';
          }
        })
        .catch(error => {
        // redirect to login
          if (error.response && error.response.status === 403) {
            proxy.loginUser();
          } else {
            console.log(error);
            proxy.userIsLoading = false;
            proxy.errorMessage = 'api_error_main';
          }
        });
    } else {
      // verify token
      return this.fetchUserData();
    }
  }

  getLocation (href) {
    var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
      href: href,
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7]
    };
  }

  loginUser () {
    let proxy = this;
    if (window.hasOwnProperty('parentIFrame')) {
      const parentLocation = this.getLocation(this.parentUrl);

      localStorage.setItem('coeRedirectHash', parentLocation.hash);
      const parentHost = parentLocation.protocol + '//' + parentLocation.hostname;
      let loginUrl = '/connect/ciam?_destination=' + parentLocation.pathname;
      let message = { 'redirectUrl': loginUrl };

      window.parentIFrame.sendMessage(JSON.stringify(message), parentHost);
      return false;
    } else {
      setTimeout(function () {
        if (window.hasOwnProperty('parentIFrame')) {
          proxy.loginUser();
        } else {
          alert('please login to CIAM (https://www.mercedes-benz.com/connect/ciam) on another browser tab and reload this page!');
          return false;
        }
      }, 2000);
    }
  }

  @Provide('fetchUserData')
  fetchUserData () {
    let urls = $('#api-links').data('api-links');
    let proxy = this;
    let url = urls.apiUserLoginCheck + '?access_token=' + this.user.token;
    return axios.get(url, { responseType: 'json' }).then(function (response) {
      if (response.data.status === 'success') {
        Vue.set(proxy.user, 'userData', response.data.data);

        proxy.dataStorageId = proxy.user.userData.ciamID + '-data-storage';
      } else {
        proxy.errorMessage = response.data.message;
      }
      proxy.userIsLoading = false;
    });
  }

  @Provide('fetchUserOrderList')
  fetchUserOrderList () {
    let urls = $('#api-links').data('api-links');
    let url = urls.apiOrderList;
    return axios.get(url, { responseType: 'json' }).then(function (response) {
      return response.data;
    });
  }

  @Provide('saveStorageData')
  saveStorageData () {
    localStorage.setItem(this.dataStorageId, JSON.stringify(this.storageData));
    let urls = $('#api-links').data('api-links');
    axios.post(urls.apiCartUpdate, {
      'cartData': this.storageData.cart,
      'csrfToken': this.user.userData['csrfToken']
    }).then(function (response) {
      if (response.data.hasOwnProperty('status')) {
        if (response.data.status === 'success') {
          // cart successfully updated
        }
      }
    });
  }

  @Provide('getEventByUuid')
  getEventByUuid (uuid) {
    if (this.eventsData.events.hasOwnProperty(uuid)) {
      return this.eventsData.events[uuid];
    }
    return null;
  }

  @Provide('addToCart')
  addToCart (event, selectedVarieties) {
    // block seats
    let url = $('#api-links').data('api-links');
    let proxy = this;
    return axios.post(url.apiSeatsTakenBlockSeats, {
      'eventUuid': event.uuid,
      'eventHasVarietyUuid': selectedVarieties.driver.eventHasVariety.uuid,
      'selectedAmount': selectedVarieties.driver.amount,
      'csrfToken': this.user.userData['csrfToken']
    }).then(function (response) {
      if (response.data.hasOwnProperty('status')) {
        if (response.data.status === 'success') {
          Vue.set(proxy.storageData.cart, event.uuid,
            {
              'selectedVarieties': selectedVarieties
            }
          );
          proxy.saveStorageData();
        }
      }

      return response.data;
    });
  }

  @Provide('removeFromCart')
  removeFromCart (eventUuid) {
    if (this.storageData.cart[eventUuid]) {
      Vue.delete(this.storageData.cart, eventUuid);
      Vue.delete(this.storageData.forms.stepTwo, eventUuid);
      Vue.delete(this.storageData.forms.stepThree, eventUuid);
      this.$eventBus.$emit('varietiesUpdated', {
        'event': this.getEventByUuid(eventUuid),
        'action': 'remove'
      });
      this.saveStorageData();
    }
  }

  @Provide('clearCart')
  clearCart () {
    Vue.set(this.storageData, 'cart', {});
    Vue.set(this.storageData.forms, 'stepOne', {});
    Vue.set(this.storageData.forms, 'stepTwo', {});
    Vue.set(this.storageData.forms, 'stepThree', {});
    Vue.set(this.storageData.forms, 'stepFour', {});
    this.saveStorageData();
  }

  @Provide('sendConfirmation')
  sendConfirmation (emails, bookingUuid) {
    let url = $('#api-links').data('api-links');
    let proxy = this;
    return axios.post(url.apiSendConfirmation, {
      'emails': JSON.stringify(emails),
      'bookingUuid': bookingUuid,
      'csrfToken': this.user.userData['csrfToken']
    }).then(function (response) {
      if (response.data.hasOwnProperty('status')) {
        if (response.data.status === 'success') {
          //
        }
      }

      return response.data;
    });
  }

  @Provide('bookOrder')
  bookOrder () {
    let urls = $('#api-links').data('api-links');
    return axios.post(urls.apiOrderSend, {
      'csrfToken': this.user.userData['csrfToken']
    }).then(function (response) {
      return response.data;
    });
  }

  @Provide('sendOrder')
  sendOrder (bookingUuid, eventUuids, emailContents) {
    let url = $('#api-links').data('api-links');
    let proxy = this;
    return axios.post(url.apiSendOrder, {
      'bookingUuid': bookingUuid,
      'eventUuids': JSON.stringify(eventUuids),
      'emailContents': JSON.stringify(emailContents),
      'csrfToken': this.user.userData['csrfToken']
    }).then(function (response) {
      if (response.data.hasOwnProperty('status')) {
        if (response.data.status === 'success') {
          //
        }
      }

      return response.data;
    });
  }

  @Provide('editWaitingList')
  editWaitingList (eventUuid, action) {
    let url = $('#api-links').data('api-links');
    let proxy = this;
    return axios.post(url.apiWaitingList, {
      'eventUuid': eventUuid,
      'action': action,
      'csrfToken': this.user.userData['csrfToken']
    }).then(function (response) {
      if (response.data.hasOwnProperty('status')) {
        if (response.data.status === 'success') {
          //
        }
      }

      return response.data;
    });
  }

  findGetParameter (parameterName) {
    var result = null;
    var tmp = [];
    var items = location.search.substr(1).split('&');
    for (var index = 0; index < items.length; index++) {
      tmp = items[index].split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
  }

  checkToken () {
    let urls = $('#api-links').data('api-links');
    let url = urls.apiUserLoginCheck + '?access_token=' + this.user.token + '&apiTest=1';
    return axios.get(url, { responseType: 'json' }).then(function (response) {
      //
    });
  }

  getParentUrl (event) {
    if (event.data) {
      try {
        let jsonData = JSON.parse(event.data);
        this.parentUrl = jsonData.parentUrl;
      } catch (e) {
        // ignore other messages
      }
    }
  }

  created () {
    if (window.addEventListener) { // get message with parentUrl from iFrame
      window.addEventListener('message', this.getParentUrl, false);
    }

    let proxy = this;

    if (window.location.href.indexOf('app_dev.php') > -1) {
      this.user.token = 'faketoken';
    }

    Vue.set(this.promises.events, 'promise',
      new Promise(function (resolve) {
        Vue.set(proxy.promises.events, 'resolve', resolve);
      })
    );

    this.checkLogin().then(function () {
      if (!proxy.errorMessage) {
        if (localStorage.getItem(proxy.dataStorageId)) {
          let savedData = JSON.parse(localStorage.getItem(proxy.dataStorageId));
          if (savedData.hasOwnProperty('cart')) {
            if (typeof savedData.cart !== 'undefined' && !Array.isArray(savedData.cart)) {
              Vue.set(proxy.storageData, 'cart', savedData.cart);
            }
          }
          if (savedData.hasOwnProperty('forms')) {
            Vue.set(proxy.storageData, 'forms', savedData.forms);
          }
        }
        // overwrite local storage data cart with the cart from the api
        if (proxy.user.userData.cart) {
          if (!Array.isArray(proxy.user.userData.cart)) {
            Vue.set(proxy.storageData, 'cart', proxy.user.userData.cart);
          } else {
            //
          }
        }

        proxy.eventsData.events = proxy.fetchAllEvents();
        proxy.categoryData.categories = proxy.fetchAllCategories();
        proxy.organiserData.organisers = proxy.fetchAllOrganisers();

        // clean cart if there invalid entries in
        proxy.eventsData.events.then(function () {
          for (let eventUuid in proxy.storageData.cart) {
            let event = proxy.getEventByUuid(eventUuid);
            if (!event || event.type !== 'bookable') {
              proxy.removeFromCart(eventUuid);
            }
          }
        });

        proxy.redirectToSavedHash();
      }
    });
  }

  redirectToSavedHash () {
    const coeRedirectHash = localStorage.getItem('coeRedirectHash');
    if (coeRedirectHash) {
      localStorage.removeItem('coeRedirectHash');
      this.$router.push(coeRedirectHash.split('#')[1]);
    }
  }

  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/apps/booking/App.js